import { Injectable } from '@angular/core';
import { SortformsService } from '../sortforms/sortforms.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class FormSharingService {

    constructor(
        private _sortFormService: SortformsService,
        private _snackBar: MatSnackBar
    ) { }

    private getHostName() {
        return document.location.protocol + '//' + window.location.host + '/';
    }

    openSnackBar(message) {
        this._snackBar.open(message, "Ok", {
            duration: 2000
        });
    }

    copyToClipboard(text) {
        const selBox = document.createElement('textarea');
        selBox.style.position = 'fixed';
        selBox.style.left = '0';
        selBox.style.top = '0';
        selBox.style.opacity = '0';
        selBox.value = text;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand('copy');
        document.body.removeChild(selBox);
        this.openSnackBar("URL link copied to clipboard");
    }

    copyFormURLLink(template) {
        if (template.sharing && template.sharing.url_link && template.sharing.url_link.id) {
            this.copyToClipboard(`${this.getHostName()}sort-sharing/url-link/${template.sharing.url_link.id}`);
        } else {
            // Generate inactive link
            let requestData = {
                templateId: template._id,
                isActive: false
            };
            this._sortFormService.generateSharedLink(requestData).subscribe((response: any) => {
                if (response["success"]) {
                    if (!template.sharing) {
                        template.sharing = {};
                    }
                    template.sharing.url_link = response["data"];
                    template.is_url_active = false; // Ensure local toggle reflects inactive state
                    this.copyToClipboard(`${this.getHostName()}sort-sharing/url-link/${template.sharing.url_link.id}`);
                } else {
                    this.openSnackBar("Error generating link");
                }
            }, (error) => {
                console.error(error);
                this.openSnackBar("Server side error occurred");
            });
        }
    }

    activateURL(templateId, index, templates) {
        let requestData = {
            templateId: templateId
        };

        this._sortFormService.generateSharedLink(requestData).subscribe((response: any) => {
            if (response["success"]) {
                templates[index]["is_url_active"] = true;
                // Update the sharing object in the local template so the copy link works immediately
                if (!templates[index]["sharing"]) {
                    templates[index]["sharing"] = {};
                }
                templates[index]["sharing"]["url_link"] = response["data"];

                this.openSnackBar(response["message"]);
            } else {
                this.openSnackBar("Server side error occurred")
            }
        }, (error) => {
            console.log(error);
            this.openSnackBar("Server side error occurred")
        })
    }

    deactivateURL(templateId, index, templates) {
        let requestData = {
            templateId: templateId,
        };

        this._sortFormService.disableSharedLink(requestData).subscribe((response: any) => {
            if (response["success"]) {
                templates[index]["is_url_active"] = false;
                // Update local state to reflect deactivation
                if (templates[index]["sharing"] && templates[index]["sharing"]["url_link"]) {
                    templates[index]["sharing"]["url_link"]["is_active"] = false;
                }
                this.openSnackBar(response["message"]);
            } else {
                this.openSnackBar("Server side error occurred")
            }
        }, (error) => {
            console.log(error);
            this.openSnackBar("Server side error occurred")
        });
    }
}
